import { WarningIcon } from "../../components/WarningIcon/WarningIcon";

export function QueueWarning() {
  return (
    <div className="flex flex-col items-center justify-center gap-2 text-center">
      <div className="flex flex-col items-center text-lg font-semibold text-red-600">
        <WarningIcon />
        <h2>Atenção</h2>
      </div>

      <p>
        Para melhor atender nossos clientes e motoristas, no momento, estamos em manutenção de nosso sistema e{" "}
        <b>a entrada de novos veículos na fila está indisponível temporáriamente.</b>
      </p>

      <strong>Em breve, a entrada de novos veículos será liberada novamente.</strong>
    </div>
  );
}
